export default __webpack_public_path__ + "static/media/img_tutor_howitworks_02@medium.d9ecea0b.png";